import { render, staticRenderFns } from "./solicitacao-pessoa-juridica.vue?vue&type=template&id=708513c4&"
import script from "./solicitacao-pessoa-juridica.vue?vue&type=script&lang=js&"
export * from "./solicitacao-pessoa-juridica.vue?vue&type=script&lang=js&"
import style0 from "./solicitacao-pessoa-juridica.vue?vue&type=style&index=0&id=708513c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports